<template>
    <div class="eon-multiselect-field" :style="'width: ' + width + 'px;'">
        <span class="p-float-label">
            <MultiSelect :id="name" v-model="internalValue" :options="internalItems" display="chip"
                         :optionLabel="itemLabel" :optionValue="itemValue" :placeholder="placeholder"
                         @update:modelValue="handleChange" @blur="handleBlur" />
            <label :for="name">{{ placeholder }}</label>
        </span>
        <span v-show="errorMessage" class="p-invalid">
            <i class="pi pi-exclamation-triangle" /> {{ errorMessage }}
        </span>
    </div>
</template>
<script>
    import MultiSelect from "primevue/multiselect";
    import {useField} from "vee-validate";

    export default {
        name: "EonMultiSelect",
        props: {
            name: {
                type: String,
            },
            placeholder: {
                type: String,
                default: "",
            },
            width: {
                type: String,
            },
            label: {
                type: String,
            },
            itemLabel: {
                type: String,
            },
            itemValue: {
                type: String,
            },
            items: {
                type: Array,
                required: true,
            },
            emptyValue: {
                type: Boolean,
                default: false,
            },
            modelValue: null,
            rules: undefined,
        },

        components: {MultiSelect},

        emits: ["update:modelValue"],

        data() {
            return {
                internalItems: this.items ? [...this.items] : [],
            };
        },

        mounted() {
            if (this.emptyValue) {
                this.internalItems = [...this.items];
            }
        },

        computed: {
            internalValue: {
                get() { return this.modelValue; },
                set(value) { this.$emit("update:modelValue", value); },
            },
        },

        watch: {
            items(newVal) {
                this.internalItems = [...newVal];
            },
            internalValue: {
                handler(value) {
                    if ((!this.items || this.items?.length === 0) && value && value.length > 0) {
                        this.internalItems = [...value];
                    }
                },
                deep: true,
            },
        },

        setup(props) {
            const {
                value: inputValue,
                errorMessage,
                handleBlur,
                handleChange,
                meta,
            } = useField(props.name, props.rules, {
                initialValue: props.modelValue,
            });

            return {
                handleChange,
                handleBlur,
                errorMessage,
                inputValue,
                meta,
            };
        },

    };
</script>

<style lang="less">
@import "../assets/less/eon-multiselect.less";
@import "../assets/less/eon-checkbox.less";
</style>
